import React from 'react'
import { useTranslation } from 'react-i18next'

require('./LowPerformanceModal.scss')

const LowPerformanceModal = () => {
    const { t } = useTranslation()
    return (
        <div className="LowPerformanceModal">
            <div className="content">
                <img src={`${ASSET_BUCKET}/graphics/sad_bear.jpg`} alt="" />
                <div className="header">{t('common.low performance header')}</div>
                <div className="body">{t('common.low performance body')}</div>
                <a
                    /* eslint-disable-next-line max-len */
                    href="//support.mysugarcube.com/hc/en-us/articles/360052559294-Why-is-my-design-experience-running-in-Low-performance-mode-"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('common.learn more')}
                </a>
            </div>
        </div>
    )
}

export default LowPerformanceModal
